<template>
  <div>
    <h1>LOKII-CE Dashboard</h1>

    <br/>


  </div>





  <TabView>
    <TabPanel header="User Information">

          <br/>
            <h3>Welcome back: {{ username }}</h3>
          <br/>


           <DataTable
            :value="userInfos"
            dataKey="id"
            responsiveLayout="scroll"
            class="p-datatable-gridlines"
          >  
            <Column field="code" header="Data" style="width: 30%" > </Column>
            <Column field="name" header="Value" style="width: 70%"  > </Column>   
          </DataTable>

    </TabPanel>


    <TabPanel header="Sensor data Viewing">
          <br/>
          <h3>You are using LOKII-CE SMARTSHIELD: {{ smartShieldStr }}</h3>
          <br/>

          Click  SMART_IOT device button  to check its internal sensor data.

          <br/>
          <br/>
          <SelectButton v-model="value1" :options="options" @click="setFirebaseSeries()" />
          <br/> <br/>



          Click download button to download all the SMART_IOTs sensor data for post processing.
          <br/>
          <br/>
          <br/>

         <Button @click="downloadCSV(30)" style="width: 30%" >   Export  smartIOT: {{smartIOTNumber}} data  to CSV file </Button>
        .. .. 
         <Button @click="downloadCSV(1000)" style="width: 30%" > Export  ALL smartIOT:{{smartIOTNumber}} data to CSV file </Button>

        <br/> <br/>


          <Panel header="Temperature and Humidity sensor" :toggleable="true"  :collapsed="true">
            <ChartTemp ref="chartTemp" />
          </Panel>
           
          <Panel header="Gas sensor" :toggleable="true"  :collapsed="true" > 
            <ChartGas ref="chartGas" />
          </Panel>

          <Panel header="9-axis IMU sensor" :toggleable="true" :collapsed="true"> 
            <ChartBno ref="chartBno" />
          </Panel>

          <Panel header="Sound volume sensor" :toggleable="true" :collapsed="true"> 
            <ChartSound ref="chartSound" />
          </Panel>

          <Panel header="Light sensor" :toggleable="true" :collapsed="true"> 
            <ChartLight ref="chartLight" />
          </Panel>

          <Panel header="Time of Flight sensor" :toggleable="true" :collapsed="true">   
            <ChartDist ref="chartDist" />
          </Panel>

    </TabPanel>


    <TabPanel header="Sensor data Control">


          <br/>
          <h3>You are using LOKII-CE SMARTSHIELD: {{ smartShieldStr }}</h3>
          <br/>



<table>

  <tr>
    <td> Sensor report frequency : {{reportFrequency}} seconds: </td>
    <td>  <Button id="btnOff"  @click="turnOffSmartIOT(0)"  v-bind:class="{'black': reportFrequency==0, 'blue': reportFrequency!=0}"    style="width: 80%"  >  Turn OFF smart IOT Device  </Button>  </td>
    
  </tr>
  <tr>
    <td> </td>
    <td> <Button id="btnOn1"  @click="turnOnSmartIOT(1)" style="width: 80%"  v-bind:class="{'black': reportFrequency==1, 'blue': reportFrequency!=1}"   >    Turn ON sensor data reporting for every second   </Button>  </td>
 
  </tr>

  <tr>
    <td> </td>
    <td> <Button id="btnOn5"  @click="turnOnSmartIOT(5)"  style="width: 80%"  v-bind:class="{'black': reportFrequency==5, 'blue': reportFrequency!=5}" >     Turn ON sensor data reporting for every 5 seconds   </Button>  </td>
  </tr>


  <tr>
    <td> </td>
    <td> <Button id="btnOn10"  @click="turnOnSmartIOT(10)"  style="width: 80%"  v-bind:class="{'black': reportFrequency==10, 'blue': reportFrequency!=10}" >     Turn ON sensor data reporting for every 10 seconds   </Button>  </td>
  </tr>
 

   <tr>
    <td> </td>
    <td> <Button id="btnOn60"  @click="turnOnSmartIOT(60)" style="width: 80%"  v-bind:class="{'black': reportFrequency==60, 'blue': reportFrequency!=60}"  >    Turn ON sensor data reporting for  every 1 minute   </Button>  </td>
 
  </tr>
 

   <tr>
    <td> </td>
    <td> <Button id="btnOn300"   @click="turnOnSmartIOT(300)"  v-bind:class="{'black': reportFrequency==300, 'blue': reportFrequency!=300}"     style="width: 80%"  >     Turn ON sensor data reporting for every 10 minutes  </Button>  </td>
 
  </tr>
 
 
 

 
</table>

            

            



    </TabPanel>

  </TabView>












<br/> <br/>








</template>


<style>
  .blue {
    background-color:  #2196F3 ;
  }
  .black {
    background-color:   #003FFF;
  }
</style>


// ------------- script -----------------

<script>
// firebase
// shallow cannot be used with any of the "filtering data" query parameters.

// eslint-disable-line

/*
  <button
      class="badge badge-primary mr-2"

      @click="setFirebaseSeries()"
    >
          Test Button
    </button>

    <button class="badge badge-danger mr-2" @click="deleteTutorial">
      Delete
    </button>

// not working at vue3....
 import iOS13SegmentedControl from "vue-ios13-segmented-control.vue";
*/


// npm install jquery --save-dev
import { auth, database } from "../firebaseInit"; // eslint-disable-line
 

import ChartTemp from "./ChartTemp";
import ChartGas from "./ChartGas";
import ChartBno from "./ChartBno";
import ChartSound from "./ChartSound";
import ChartLight from "./ChartLight";
import ChartDist from "./ChartDist";


import { ref } from 'vue'

import jQuery from "jquery";


/*
 
var gUserName = ref ("");
var gSmartShieldStr = ref("smartIOT-669A28");
*/




var recordCount = 30;

/*
 var email = "Markuz"; // eslint-disable-line
var smartShieldStr = "smartIOT-669A28"; // Smart Shield ID

// var iotNumber = 1;
var prevIotNumber = -1;
*/
  


const radio1 = ref('New York')       // eslint-disable-line

export default {
  name: "Dashboard",

  components: {

 
  
    ChartTemp,
    ChartGas,
    ChartBno,
    ChartSound,
    ChartLight,
    ChartDist,
  },


 data() {
        return {

         
            value1: '',
            options: ['smartIOT-1','smartIOT-2','smartIOT-3','smartIOT-4','smartIOT-5','smartIOT-6','smartIOT-7','smartIOT-8'],
            smartIOTNumber: 1,
            smartShieldStr : "",
            username: "Test",

            userInfos: null,
            reportFrequency: 1,

            prevIotNumber : -1,


        }
    },

 async mounted() {   

    
   
     if (auth.currentUser) {
        var userId = auth.currentUser.uid; // eslint-disable-line



        // this.smartShieldStr  = "aaaaaaaaaaaaaaaa";
        // this.username = "44444444444444444";



        var snapshot = await  database
              .ref("/user-accounts/" + userId + "/")
              .once("value"); 

        if( snapshot.exists() ) {


          var email =  snapshot.val().email;
          //console.log("----------->  "  , snapshot.val().smartshield );
          //console.log("----------->  "  , snapshot.val().username );

          this.smartShieldStr  =  snapshot.val().smartshield ;
          this.username =  snapshot.val().username;

          this.userInfos =  [
            {
              id: "0",
              code: "User Name",
              name:    this.username ,
              
            },
            {
              id: "1",
              code: "User ID",
              name:  userId ,
              
            },  
            {
              id: "2",
              code: "Email",
              name: email,
              
            }, {
              id: "3",
              code: "SMART_SHEILD ID",
              name:   this.smartShieldStr,
              
            }, {
              id: "4",
              code: "Number of SMART_IOTs",
              name: "8",
              
            },

            ];


        }
     }

  },

  methods: {


    turnOnSmartIOT(f) {

      //const $ = jQuery;
      //window.$ = $;

      this.reportFrequency = f;

      const urlVar = 'https://us-central1-basic-fact-322011.cloudfunctions.net/httpRequest?interval='+ f + '&smartIOT=' + this.smartShieldStr;
      console.log(urlVar);

      jQuery.ajax({
                url: urlVar,
            });

    },



    turnOffSmartIOT() { 


      this.reportFrequency = 0;
      const urlVar = 'https://us-central1-basic-fact-322011.cloudfunctions.net/httpRequest?interval=0&smartIOT=' + this.smartShieldStr;
      console.log(urlVar);

       jQuery.ajax({
                url: urlVar,
            });

    },




    // define vue3 function to call normal JS function
    setFirebaseSeries() {

      var smartIOTStr = this.value1;
      this.smartIOTNumber = smartIOTStr[smartIOTStr.length - 1] - '0';
      
      console.log("This number is :" +  this.smartIOTNumber + " and prevIotNumber is " + this.prevIotNumber);

    /*
      // unregister IOT      
      if (this.prevIotNumber != -1) {

        /*
         database
    .ref("/devices-telemetry/" + smartIOTStr + "/" + this.prevIotNumber)
    .orderByChild("timestamp")
    .limitToLast(recordCount)
    .off("value");
        // database.ref("/devices-telemetry/" +smartIOTStr  + "/" + this.prevIotNumber).off();
        console.log( "########  Unregister the old firebase database iot callback : ", this.prevIotNumber );
      }
      */
    
      // this off seem working
      for (var i=1; i<=8; i++) {
            database.ref("/devices-telemetry/" + this.smartShieldStr + "/" + i).off();
      }

      getFirebaseData(this.smartShieldStr, this.smartIOTNumber , recordCount);
    

      this.prevIotNumber = this.smartIOTNumber;
   
    },

    downloadCSV(numCount) {
        readFirebaseAsCSV(this.smartShieldStr, this.smartIOTNumber, numCount ) ;
    },
  },


};


//------------------------------------------------------
//
//            end  VUE3 component 
//
//------------------------------------------------------



function getFirebaseData(smartShieldStr, iotNumber, recordCount) {

// -------------------- Function ---------------

          function updateIOTChart(snapshot) {

                let d = 0;
                let tempSeries = [[], []];
                let gasSeries = [[], []];
                let bnoSeries = [[], [], [], [], [], [], [], [], []];
                let soundSeries = [[]];
                let lightSeries = [[]];
                let distSeries = [ []];

               // compute the fixed-point number from int16
                function Int32ToInt16(num, fixPointNum) {
                
                  if (num > (65536 / 2) - 1) {
                      num = num - 65536;
                  }
                  num = num / fixPointNum
                  return num;
              }


              snapshot.forEach(function (item) {

                // d = new Date(item.val().timestamp * 1000);
                d = item.val().timestamp * 1000;
                  // Temperature
                  tempSeries[0].push([d, item.val().temperature]);
                  tempSeries[1].push([d, item.val().humidity]);

                  // Gas
                  gasSeries[0].push([d, item.val().CO2]);
                  gasSeries[1].push([d, item.val().tvoc]);

                  // accelerometer
                  bnoSeries[0].push([d,    Int32ToInt16(item.val().accels[0], 256.0)    ]);
                  bnoSeries[1].push([d,    Int32ToInt16(item.val().accels[1], 256.0)    ]);
                  bnoSeries[2].push([d,    Int32ToInt16(item.val().accels[2], 256.0)    ]);
                  // gyro
                  bnoSeries[3].push([d,    Int32ToInt16( item.val().gyros[0], 512.0)    ]);
                  bnoSeries[4].push([d,    Int32ToInt16( item.val().gyros[1], 512.0)    ]);
                  bnoSeries[5].push([d,    Int32ToInt16( item.val().gyros[2], 512.0)    ]);
                  // magnet
                  bnoSeries[6].push([d,    Int32ToInt16(item.val().mags[0], 16.0)  ]);
                  bnoSeries[7].push([d,    Int32ToInt16(item.val().mags[1], 16.0)  ]);
                  bnoSeries[8].push([d,    Int32ToInt16(item.val().mags[2], 16.0)  ]);

                  // sound volume
                  soundSeries[0].push([d, item.val().soundLevel]);

                  // distance
                  distSeries[0].push([d, item.val().dist]);
                  
                  // light
                  lightSeries[0].push([d, item.val().lux]);
                });

                // after update,  synchronize the data to the chart
                window.iotChartTemp.setDataSeries(tempSeries);
                window.iotChartGas.setDataSeries(gasSeries);
                window.iotChartBno.setDataSeries(bnoSeries);
                window.iotChartSound.setDataSeries(soundSeries);
                window.iotChartLight.setDataSeries(lightSeries);
                window.iotChartDist.setDataSeries(distSeries);
                console.log("Update SMARTIOT[" + iotNumber + "] - at time: " + d);
          }

// ------------------------------------


   
  console.log(
    "==> locate database from" +
      "/devices-telemetry/" +
      smartShieldStr +
      "/" +
      iotNumber +
      " " +
      recordCount
  );


/*
  // clear the old series
  window.iotChartTemp.clearDataSeries();
  window.iotChartGas.clearDataSeries();
  window.iotChartBno.clearDataSeries();
  window.iotChartSound.clearDataSeries();
  window.iotChartLight.clearDataSeries();
  window.iotChartDist.clearDataSeries();

*/



  database
    .ref("/devices-telemetry/" + smartShieldStr + "/" + iotNumber)
    .orderByChild("timestamp")
    .limitToLast(recordCount)
    .on("value", updateIOTChart );
}
// end firebase get udpate function



/*
async  function setFirebaseSeriesWeb(iotNumber) {

  if (auth.currentUser) {
    var userId = auth.currentUser.uid; // eslint-disable-line
    //   {"username": "Edward", "email" : "edward@centek.com.hk","smartshield" : "smartIOT-669A28"}

    // read the status
    database
      .ref("/user-accounts/" + userId + "/")
      .once("value", function (snapshot) {
        console.log(">>>>>>>>>>>>>>>>    ", snapshot.val()); //  SMARTIOT-669A28

        gSmartShieldStr.value =   snapshot.val().smartshield; //    snapshot.val();
        gUserName.value  =    snapshot.val().username;

        //if (name.length > 0 )
        //  writeUserData(userId, name, userEmail, smartShieldStr) ;
        // else
        getFirebaseData(gSmartShieldStr.value, iotNumber, recordCount);

        console.log("====> 1");
        return snapshot;
      });
  }
}
*/


// ----------------------------
// read the firebase IOT record as a CSV file
//-----------------------------
function readFirebaseAsCSV(  smartshieldStr , iotNumber, numRecord) {
  database
    .ref("/devices-telemetry/" +smartshieldStr + "/" + iotNumber)
    .orderByChild("timestamp")
    .limitToLast(numRecord)
    .once("value", (snapshot) => {

      var  strHeader = "Timestamp,Temperature (Degree),Humidity(%),CO2 (ppm), TVOC (ppm),Accel-X (m/s-2),Accel-Y (m/s-2),Accel-Z (m/s-2), " +
                      "Gyro-X (rad/s), Gyro-Y (rad/s), Gyro-Z (rad/s),Mag-X (uTesla),Mag-Y (uTesla),Mag-Z (uTesla),Sound Level, Luminance (Lux), Proximity distance (mm)" +
                      '\r\n';   
                       
      snapshot.forEach(function (item) {

        var line = (item.val().timestamp * 1000) + "," +  item.val().temperature  + "," + item.val().humidity
                  + "," +  item.val().CO2 + "," + item.val().tvoc
                  + "," +  (item.val().accels[0] / 256.0) +  "," +  (item.val().accels[1] / 256.0)  +       "," +  (item.val().accels[2] / 256.0)
                  + "," + (item.val().gyros[0] / 512.0) + "," + (item.val().gyros[1] / 512.0)  + "," + (item.val().gyros[2] / 512.0)
                  + "," + (item.val().mags[0] / 16.0 ) + "," + (item.val().mags[1] / 16.0 ) + "," + (item.val().mags[2] / 16.0 )
                  + "," + (item.val().soundLevel) + "," + item.val().lux + ","+ item.val().dist + '\r\n';   
                  
        strHeader = strHeader + line;
      });

      openSaveFileDialog(strHeader, "smartIOT_data" + iotNumber + ".csv", "text/csv");





    });
}

// ----------------------------
// open Save file dialog
//-----------------------------
function openSaveFileDialog(data, filename, mimetype) {
  if (!data) return;

  var blob =
    data.constructor !== Blob
      ? new Blob([data], { type: mimetype || "application/octet-stream" })
      : data;

  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, filename);
    return;
  }

  var lnk = document.createElement("a"),
    url = window.URL,
    objectURL;

  if (mimetype) {
    lnk.type = mimetype;
  }

  lnk.download = filename || "untitled";
  lnk.href = objectURL = url.createObjectURL(blob);
  lnk.dispatchEvent(new MouseEvent("click"));
  setTimeout(url.revokeObjectURL.bind(url, objectURL));
}

/*
function testButton() {

   console.log("Test button");
}
*/

// setTimeout(() => setFirebaseSeriesWeb(1), 1000);

/*

// ----------------------------
//   Need firebase-admin account access
// ----------------------------
function writeUserData(userId, name, email, smartShieldId) {

  // push    -  generate a random index
  // set     -  set at
  database().ref('/user-accounts/' + userId).push({
    username: name,
    email: email,
    smartshield : smartShieldId,
  });
}
*/
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>

// ------------- end script --------------
